import AuthorizeGuard from "./AuthorizeGuard";

export default AuthorizeGuard;
